var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgSurveyIcon(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M50.001 4v37a1 1 0 01-1 1H34.619l5.276 8.553a1 1 0 11-1.789.894L32.382 42h-6.381v8A1 1 0 1124 50v-8h-6.381l-5.724 9.447a1 1 0 11-1.789-.894L15.382 42H1a1 1 0 01-1-1V4a2 2 0 012-2h22V1a1 1 0 112.001 0v1h22a2 2 0 012 2zm-2 0H2v2h46.001V4zm0 4H2v32h46.001V8zM5 34h1v-7a1 1 0 011-1h6a1 1 0 011 1v7h2V19a1 1 0 011-1h6a1 1 0 011 1v15h2.001v-9a1 1 0 011-1h6a1 1 0 011 1v9h2V13a1 1 0 011-1h6a1 1 0 011 1v21h1a1 1 0 110 2H5a1 1 0 110-2zm37.001 0V14h-4v20h4zm-10 0v-8h-4v8h4zM22 34V20h-3.999v14H22zm-9.999 0v-6H8v6h4.001z",
    fill: `url(#${_id})`,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "71.415%",
    y1: "7.565%",
    x2: "24.667%",
    y2: "87.141%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6700",
    offset: "100%"
  })))));
}
export default SvgSurveyIcon;